/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

import store from "features/store";
import { Button } from "react-bootstrap";
import { membershipicon } from "shared/images/images";

export function addDataLayer(data) {
    window.dataLayer.push(data);
}

export function getItemUrl(saleid, itemid, itemseourl) {
    return itemseourl ? `/estate-sale/${saleid}/item/${itemid}/${itemseourl}` : `/estate-sale/${saleid}/item/${itemid}`;
}

export const getFormattedAppleLinkAndMessage = (errorMessage) => {
    // Handling for getting apple link from the error message
    let message = '';
    let link = null;
    if ( typeof errorMessage === 'string' && errorMessage.includes('APPLELINK') ) {
        let arr = errorMessage.split("APPLELINK");
        message = arr[0];
        link = arr[1];
    } else {
        message = errorMessage;
    }

    return { message, link };
}

let PM_STEPS = null;

export const setPmSteps = (profile) => {
    const pmNewUserSteps = [
        {key: "profilecompleted", screen: '/my-account/my-info/personal-info'},
        // {key: "interestCompleted", screen: '/my-account/my-info/personal-interests'},
        {key: "paymentcompleted", screen: '/my-account/my-info/payment-methods/add'},
        {key: "membershipCompleted", screen: '/my-account/join-premier-member'}
    ]
    
    const pmReturnUserSteps = [
        {key: "profilecompleted", screen: '/my-account/my-info/personal-info'},
        {key: "paymentcompleted", screen: '/my-account/my-info/payment-methods/add'},
        {key: "membershipCompleted", screen: '/my-account/join-premier-member'},
        {key: "interestCompleted", screen: '/my-account/my-info/personal-interests'}
    ];

    PM_STEPS = profile?.['profilecompleted'] || profile?.['interestCompleted'] || profile?.['paymentcompleted'] || profile?.['membershipCompleted'] ? pmReturnUserSteps : pmNewUserSteps;
};

export const getPmCompletedSteps = (profile, allDoneScreenIsPending=false, ignoredSteps=null) => {
    let completedSteps = 0;
    let nextStep = null;
    let leftOutSteps = [];

    if ( PM_STEPS ) {
        PM_STEPS.forEach(step => {
            if ( profile?.[step.key] ) {
                completedSteps++;
            } else if ( ignoredSteps && ( ignoredSteps.skipped.includes(step.screen) ||  ignoredSteps.cancelled.includes(step.screen) ) ) {
                return;
            } else if ( !nextStep ) {
                nextStep = { screen: step.screen };
            } else {
                leftOutSteps.push({ screen: step.screen });
            }
        });
    
        // If all completed making the final step also as completed
        if ( profile?.membershipCompleted ) {
            completedSteps++;
    
            // Only if the current screen is Subscription Screen
            if ( allDoneScreenIsPending && !nextStep ) {
                nextStep = { screen: '/my-account/premier/thankyou' };
            }
        }
    }
    

    return { completedSteps, nextStep, leftOutSteps };
};

export const pmAutoNavigateToNextScreen = (props, previousProfile, currentProfile, keyToCheck, fallbackRoute=null, forceSkip=false, forceNavigation=false, forceCancel=false) => {
    let screen = null, navigation = props.history, pmProgressData = null, allDoneScreenIsPending = props?.location?.allDoneScreenIsPending ? true : false;
    let ignoredSteps = {
        skipped: props?.location?.ignoredSteps?.skipped ? props.location.ignoredSteps.skipped : [], 
        cancelled: props?.location?.ignoredSteps?.cancelled ? props.location.ignoredSteps.cancelled : [] 
    };

    if ( forceNavigation ) {
        pmProgressData = getPmCompletedSteps(previousProfile, allDoneScreenIsPending, ignoredSteps);
    } else if ( forceSkip ) {
        ignoredSteps.skipped.push(props.location?.pathname);
        pmProgressData = getPmCompletedSteps(previousProfile, allDoneScreenIsPending, ignoredSteps);
    } else if ( forceCancel ) {
        ignoredSteps.cancelled.push(props.location?.pathname === '/my-account/premier-plan' ? '/my-account/join-premier-member' : props.location?.pathname);
        pmProgressData = getPmCompletedSteps(previousProfile, allDoneScreenIsPending, ignoredSteps);
    } else if ( previousProfile[keyToCheck] == 0 && currentProfile[keyToCheck] == 1 ) {
        allDoneScreenIsPending = keyToCheck === 'membershipCompleted' ? true : (allDoneScreenIsPending || false);
        pmProgressData = getPmCompletedSteps(currentProfile, allDoneScreenIsPending, ignoredSteps);
    }

    screen = pmProgressData?.nextStep?.screen ? pmProgressData.nextStep.screen : null;

    if ( screen ) {
        if ((props.location?.pathname === '/plans' || props.location?.pathname === '/premier-membership') && screen === '/my-account/join-premier-member') {
            screen = '/my-account/premier-plan';
        } else if (['/estate-sale/list', '/locations'].includes(props.location?.pathname)) {
            screen = '/my-account/join-premier-member'; 
        }
        navigation.push({pathname: screen, allDoneScreenIsPending, ignoredSteps });
    } else if ( fallbackRoute ) {
        navigation.push(fallbackRoute);
    } else if (pmProgressData?.leftOutSteps?.length === 0) {
        navigation.push('/');
    }
};

const navigateToVip = (props, screentype) => {
    if (props.user.suspensionstatus == "ALL") {
        store.dispatch({ type: 'TOGGLE_SUSPEND_MODAL', payload: true });
    }
    else {
        if (props.user.id) {
            pmAutoNavigateToNextScreen(props, props.user, null, null, null, false, true);
        } else {
            store.dispatch({ type: 'TOGGLE_SIGNIN_MODAL', payload: { open: true, mode: 'Sign-In', fromBannerBtn: true } });
        }
    }
    let dataLayerData = {
        'event': 'join_premier',
        'title': screentype
    }
    addDataLayer(dataLayerData);
}

export const bannerImage = (props, screen) => {  
    const isVipMember = props.history.location.pathname === '/my-account/join-premier-member';
    return (
        <div className="mt-3 banner-background resp-banner-text p-2 clickable" style={{ margin: `${isVipMember ? "0px" : "0px 5px 20px" }`, width: `${isVipMember ? "100%" : "1410px" }` }} onClick={() => {navigateToVip(props, screen)}}>
            <div className="d-flex align-items-center mobile-banner-resp pl-2" style={{ width: "70%" }}>
                <div className="w-20 d-flex justify-content-center align-items-center">                
                    <img src={membershipicon} className="ml-2 shild-img" alt="banner-img"/>
                </div>
                <div className="d-flex justify-content-center flex-column text-mobile-resp w-80">
                    <div className="vip-heading-font">Unlock Exclusive Benefits</div>
                    <div className="vip-sub-headding text-mobile-resp">Your Premier Membership Awaits for $99/year</div>
                </div>
            </div>
            <div className="d-flex justify-content-center align-items-center p-2 resp-banner-btn" >
                <Button className="banner-btn">Join CTBids Premier</Button>
            </div>
        </div>
    )
}

export const pmBannerImage = (membershipdata, props, screen) => {  
    const isVipMember = props.history.location.pathname === '/my-account/join-premier-member';
    return (
        <div className="mt-3 pm-banner-background resp-banner p-3 clickable" style={{ width: "85%"  } } >
            <div className="d-flex align-items-center mobile-banner-resp pl-2" >
                <div className="d-flex justify-content-center align-items-center">                
                    <img src={membershipicon} className="ml-2 shild-img" alt="banner-img"/>
                </div>
                <div className="d-flex justify-content-center">
                    <div className="heading-font">{membershipdata.description}</div>
                </div>
            </div>
            <div className="d-flex justify-content-center align-items-center p-3" >
                <Button onClick={()=> {
                    let dataLayerData = {
                        'event': 'premier_jointoday'
                    }
                    addDataLayer(dataLayerData);
                    props.history.push('/plans')
                }} className="pm-banner-btn">{membershipdata.button}</Button>
            </div>
        </div>
    )
}

export function eCommunication(data) {
    // let text = text.replace(/HREFSTART(.*?)HREFEND/g, (value) => {
    //     let parts = value.split("#");
    //     if(parts[1] == "phone") {
    //             return `<a href="tel:${parts[2]}">${parts[2]}</a>`;
    //     } else if(parts[1] == "website") {
    //             return `<a href="${parts[3]}">${parts[2]}</a>`;
    //     } else if(parts[1] == "email") {
    //             return `<a href="mailto:${parts[2]}">${parts[2]}</a>`;
    //     }
    // });
    if (data?.includes('#EMAILREF#')) {
        const parts = data.split('#EMAILREF#');
        return parts.map((part, index) => {
            if (index === 1) {
                const emailparts = part.split('#');
                return (
                    <>
                    <a className="mail-link"  style={{ color: '#00263E', fontWeight:'bold' }}   key={index} href={`mailto:${emailparts[0]}`} >
                        {emailparts[1]}
                    </a>
                    {emailparts[2] && emailparts[2]}
                    </>
                );
            } else {
                return <span key={index}>{part}</span>;
            }
        });

    } else if (data?.includes('#TELEREF#')) {
        const parts = data.split('#TELEREF#')
        return parts.map((part, index) => {
            if (index === 1) {
                const phone = part.split('#');
                return (
                    <a className="mail-link" style={{ color: '#00263E', fontWeight:'bold' }}  key={index} href={`tel:${phone[1]}`} >
                        {phone[0]}
                    </a>
                );
            } else {
                return <span key={index}>{part}</span>;
            }
        });
    } else {
        return data;
    }
}

export const getGoogleAdData = (data, interval) => {
    data.map((elem, index) => { 
        if ( index != 0 && (index + 1) % interval == 0 ) {
            elem['showAd'] = true;
        }
    });
}

export const setItemPreviousNextInSessionStorage = (list, currentIndex, pageIndex, pageCount) => {
    window.sessionStorage.setItem("previousNext", JSON.stringify({ list: list, fullList: list, currentIndex: currentIndex, currentPageIndex: pageIndex, page : pageCount }));
};

export const mergeItemPreviousNextInSessionStorage = (list, currentIndex,pageIndex) => {
    let previousNextSessionData = window.sessionStorage.getItem("previousNext");
    previousNextSessionData = typeof previousNextSessionData === 'string' ? JSON.parse(previousNextSessionData) : {};

    window.sessionStorage.setItem("previousNext", JSON.stringify({...previousNextSessionData, list: list, currentIndex: currentIndex,currentPageIndex: pageIndex}));
};

export const trimText = (text, maxLength) => {
    if (text.length <= maxLength) return text;
    return text.slice(0, maxLength) + '...';
};